document.addEventListener('DOMContentLoaded', function() {  
  // Set interval to check for the presence of the 'Add to Cart' button
  const checkAddToCartButtonInterval = setInterval(function() {
    if (document.querySelectorAll('.cbb-also-bought-add-to-cart-button').length > 0) {
      document.querySelectorAll('.cbb-also-bought-add-to-cart-button').forEach(oldButton => {
        const buttonText = oldButton.textContent.trim();
        const newButton = document.createElement('button');
        newButton.className = 'cbb-also-bought-add-to-cart-button-ajax';
        const span = document.createElement('span');
        span.className = 'translatable';
        span.textContent = buttonText;
        newButton.appendChild(span);
        oldButton.insertAdjacentElement('afterend', newButton);
        oldButton.remove();
      });
      
      // Once the button is found, initialize the add to cart functionality
      initializeAddToCartForApp();
  
      // Clear the interval since the button is found and event listeners are set up
      clearInterval(checkAddToCartButtonInterval);
    }
  }, 200); // Check every 500ms (you can adjust the interval time)
  
  // Set a timeout to clear the interval if the button is not found within 5 seconds
  setTimeout(function() {
    clearInterval(checkAddToCartButtonInterval);
    console.log('Button not found within 5 seconds, interval cleared.');
  }, 5000); // Timeout after 5 seconds

  // Close notification handler
  document.querySelectorAll('.notification__close').forEach(closeButton => {
    closeButton.addEventListener('click', function() {
      const notificationContainer = this.closest('.notification');
      if (notificationContainer) {
        notificationContainer.classList.remove('notification--active');
        notificationContainer.setAttribute('aria-hidden', 'true');
      }
    });
  });
});

// Function to initialize the add to cart functionality
function initializeAddToCartForApp() {
  // Add event listener to all "Add to Cart" buttons for "Also Bought" section
  document.querySelectorAll('.cbb-also-bought-add-to-cart-button-ajax').forEach(function(button) {
      button.addEventListener('click', function(event) {
          button.classList.add('added');
          button.classList.add('wait');
          // Get the closest product list item and extract variant ID
          const productItem = button.closest('li.cbb-also-bought-product');
          let variantId = null;
          const variantSelect = productItem.querySelector('select');
          const notificationSuccessContainer = document.getElementById('NotificationSuccess');
          const notificationErrorContainer = document.getElementById('NotificationError');
  
          const originalButtonText = button.innerHTML;
          button.innerHTML = '•••';
          button.disabled = true;
  
          if (variantSelect && variantSelect.value) {
              variantId = variantSelect.querySelector('option[value="' + variantSelect.value + '"]').getAttribute('data-variant-id');
          } else {
              // If no select, get the variant ID from the data-href attribute of the link
              const productLink = productItem.querySelector('a');
              const urlParams = new URLSearchParams(productLink.getAttribute('data-href').split('?')[1]);
              variantId = urlParams.get('variant');
          }
  
          // If variant ID is not available, fetch it from the data-href attribute
          if (!variantId) {
              const dataHref = productItem.querySelector('a').getAttribute('data-href');
              const urlParams = new URLSearchParams(dataHref.split('?')[1]);
              variantId = urlParams.get('variant');
          }
  
          if (variantId) {
              // Make AJAX request to add product to cart
              fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                      items: [
                          {
                              id: variantId,
                              quantity: 1,
                          }
                      ]
                  })
              })
              .then(response => response.json())
              .then(data => {
                  if (data.status) {
                      // Show error notification
                      showNotification(notificationErrorContainer, data.message, true);
                      // Reset button text after error
                      button.innerHTML = originalButtonText;
                      button.disabled = false;
                      button.classList.remove('added');
                      button.classList.remove('wait');
                  } else {
                      // Show success notification
                      showNotification(notificationSuccessContainer);
                      // Change button text to "Added"
                      const addedText = 'Added';
                      button.innerHTML = addedText;
                      button.disabled = true;
                      button.classList.remove('wait');
                      setTimeout(() => {
                          button.innerHTML = originalButtonText;
                          button.disabled = false;
                          button.classList.remove('added');
                      }, 5000); // Reset text after 5 seconds
                    
                      setTimeout(() => {
                          location.reload();
                      }, 1000);
  
                      updateCartNumber();
                  }
              })
              .catch(error => {
                  // Show error notification
                  showNotification(notificationErrorContainer, error, true);
                  // Reset button text after error
                  button.innerHTML = originalButtonText;
                  button.disabled = false;
                  button.classList.remove('added');
                  button.classList.remove('wait');
              });
          } else {
              // Show error notification for missing variant ID
              showNotification(notificationErrorContainer, 'Variant ID not found.', true);
  
              // Reset button text for error
              button.innerHTML = originalButtonText;
              button.disabled = false;
              button.classList.remove('added');
              button.classList.remove('wait');
          }
      });
  });
}

// Function to show notifications
function showNotification(container, message, isError = false) {
    const notificationSuccessContainer = document.getElementById('NotificationSuccess');
    const notificationErrorContainer = document.getElementById('NotificationError');

    if (isError) {
        notificationErrorContainer.classList.add('notification--active');
        notificationSuccessContainer.classList.remove('notification--active');
        notificationErrorContainer.querySelector('.notification__message').innerHTML = message;
    } else {
        notificationSuccessContainer.classList.add('notification--active');
        notificationErrorContainer.classList.remove('notification--active');
    }

    setTimeout(function() {
        container.classList.remove('notification--active');
        container.setAttribute('aria-hidden', 'true');
    }, 5000);
}

function updateCartNumber() {
  fetch('/cart.js', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
    .then(response => response.json())
    .then(cart => {
      const totalItems = cart.items.reduce((total, item) => total + item.quantity, 0);
      const cartNumber = document.querySelectorAll('.cart-link__bubble-num');
      const cartNumberWrap = document.querySelectorAll('.cart-link__bubble');
      cartNumber.forEach(element => {
        element.innerHTML = totalItems;
      });
      cartNumberWrap.forEach(function(cartItem) {
        if (!cartItem.classList.contains('cart-link__bubble--visible')) {
          cartItem.classList.add('cart-link__bubble--visible');
        }
      });
    })
    .catch(error => console.error('Error updating cart number:', error));
}
